<template>
  <v-row
      align="center"
      justify="start"
    >
    <v-col cols="12">
      <h2 class="mb-0"> Results for Polls </h2>
      <h3 class="mt-0"> Users: {{numUsers}} </h3>
    </v-col>
    <v-col
      cols="6"
      sm="4"
      md="12"
      lg="6"
    > 
    <v-form>
      <v-select
        :items="questionsObj"  
        item-text="text"
        item-value="value" 
        label="Poll question"
        v-model="activeQuestion"
        v-on:input="fetchData()"
      ></v-select>
      </v-form>                  
    </v-col>
    <v-col
      cols="6"
      sm="4"
      md="4" 
      lg="6" 
    >       
    </v-col>


    <v-col
      cols="4"
      sm="4"
      md="4"
      
    > 
      <v-form>
        <v-select
          :items="profiles"          
          label="Profile"
          multiple
          v-model="selectedProfiles"          
        ></v-select>
      </v-form>
    </v-col>
    <v-col
      v-if="showCustomProfile"
      cols="4"
      sm="4"
      md="4"
    
    > 
      <v-form>
        <v-select
          
          :items="customProfiles"          
          label="Custom Profile"
          multiple
          v-model="selectedCustomProfiles"          
        ></v-select>
      </v-form>
    </v-col>
    <v-col
      cols="4"
      sm="4"
      md="4"
    
    > 
      <v-form>
        <v-select
          :items="countries"          
          label="Country"
          multiple
          v-model="selectedCountries"
        ></v-select>
      </v-form>
    </v-col>
    <v-col
      cols="12">
      <v-btn v-on:click="fetchFilterdData()" class="mr-1">Apply Filters</v-btn>
      <v-btn v-on:click="clearFilters()">Clear Filters</v-btn>
    </v-col>
    
    <v-col 
      cols="6"
      sm="4"
      md="6"

      >
      <bars-chart v-if="activeQuestion != '' && datacollection != null" :chart-data="datacollection" :options="options" sytle="max-height: 360px"></bars-chart>
    </v-col>
     <v-col 
      cols="6"
      sm="4"
      md="6"
      >
      <v-col 
      cols=12
      v-if="activeQuestion!=''">
        {{pollQuestion.question.default}}
      </v-col>
      <v-col 
      cols=12
      v-if="activeQuestion!=''"
      v-for="ans in pollQuestion.answers"
      :key="ans.id">
        {{ans.id}} -- {{ans.value.default}}
      </v-col>
        
    </v-col>
  </v-row>
</template>

<script>

import BarsChart from './charts/BarsChart';
import * as ApiService from '../tools/apiPoll.js';
import * as PollDB from '../tools/pollDB.js';
import * as CountryRef from '../tools/countries.js';

export default {
  name: 'Poll',
  props: {
    msg: String,
    promoCode: String,
    questions: Array,
    brandId: Number
    
  },
  components: {
        BarsChart
  },
  data(){
    return {     
      activeQuestion: '',
      selectedCountries: [],
      selectedCustomProfiles: [],
      selectedProfiles: [],
      profiles:[],
      availableProfiles:[],
      countries:[],
      availableCountries:[],
      customProfiles:[],
      availableCustomProfiles: [],
      responses: [],
      activeResponse: null,
      datacollection: null,
      numUsers:0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      },
      customProfilesGroups:[
        {
          text: "BRIDETOBE",
          disabled: false,
          value: [
            "BRIDETOBE",            
          ]
        },
        {
          text: "FASHIONLOVER",
          disabled: false,
          value: [
            "FASHIONLOVER",            
          ]
        },
        {
          text: "OTHER",
          disabled: false,
          value: [
            "OTHER",
            "null"            
          ]
        }

      ],
      profilesGroups:[
        {
          text: "PRESS/INFLUENCERS",
          disabled: false,
          value: [
            "PRENSA",
            "DIGITAL_INFLUENCER_VIP",
            "PRENSA_VIP",
            "DIGITAL_INFLUENCER",
            "MEDIA_PARTNER_ADMIN",
            "MEDIA_PARTNER_AGENT"
          ]
        },
        {
          text: "BUYERS",
          disabled: false,
          value: [
            "BUYER",
            "BUYER_VIP"
          ]
        },
        {
          text: "AUDIENCE",
          disabled: false,
          value: [
            "AUDIENCIA_VIP",
            "AUDIENCIA_GENERAL",
            "PARTNER",
            "EXHIBITOR_AGENT",
            "ORGANIZER_FIRA",
            "EXHIBITOR_ADMIN"
          ]
        },
        {
          text: "WEDDING PLANNERS",
          disabled: false,
          value: [
            "WEDDING_PLANNER_1",
            "WEDDING_PLANNER_2",
            "WEDDING_PLANNER_VIP"
          ]
        }
      ]     
    }
  },
  mounted(){
    // this.fetchQuestionIds()
    console.log("mounted poll",this.questions.length)
    if (this.questions.length > 0){
      this.activeQuestion = this.questions[0]
      this.fetchData() 
    }
  },
  methods:{
    async fetchData(){
      console.log("Fetching info for this question ",this.activeQuestion)
      let resp = await ApiService.fetchResponsesByQuestionId(this.activeQuestion)      
      this.responses = resp.responses
      /** Grouped Profiles Logic **/
      let tmpProfiles = resp.profiles.map((el) => { return {
        text: el.profile,
        value: el.profile,
        disabled: false
      }})
      this.profiles = this.getGroupedProfiles(tmpProfiles)
      //console.log("grouped",this.profiles)
      /** **/
      /** Grouped Custom profiles Logic **/
      let tmpCustomProfiles = resp.custom_profiles.map((el) => { return {
        text: el.custom_profile,
        value: el.custom_profile,
        disabled: false
      }})
      this.customProfiles = this.getGroupedCustomProfiles(tmpCustomProfiles)
      /** **/
      this.countries = resp.countries.map((el) => { return {
        text: CountryRef.countryCodes[el.country],
        value: el.country,
        disabled: false
      }})    
      this.numUsers = resp.num_users.aggregate.count 
      this.setActiveResponse()
      this.setChartData()

    },
    async fetchFilterdData(){
      if (this.selectedProfiles.length == 0 && this.selectedCountries.length == 0 && this.selectedCustomProfiles.length == 0){
        this.clearFilters()
      }else{
        let resp = await ApiService.fetchNumUsersFilteredResultsByQuestionId(this.activeQuestion,{
          profiles: this.selectedProfiles.length == 0 ? [] : this.selectedProfiles.join().split(',')
  ,
          countries: this.selectedCountries,
          custom_profiles: this.selectedCustomProfiles.length == 0 ? [] :this.selectedCustomProfiles.join().split(',')
        })
        this.numUsers = resp.num_users.aggregate.count

       resp = await ApiService.fetchFilteredResultsByQuestionId(this.activeQuestion,{
          profiles: this.selectedProfiles.length == 0 ? [] : this.selectedProfiles.join().split(','),
          countries: this.selectedCountries,
          custom_profiles: this.selectedCustomProfiles.length == 0 ? [] :this.selectedCustomProfiles.join().split(',')
        })
        this.responses = resp.responses
        /** Grouped Profiles Logic **/
        let tmpProfiles = resp.profiles.nodes.map((el) => { return {
          text: el.profile,
          value: el.profile,
          disabled: false
        }})        
        this.availableProfiles = this.getGroupedProfiles(tmpProfiles)
        
        // this.profiles.forEach((profile) => {
        //   if(!this.availableProfiles.includes(profile))
        //     profile.disabled = true
        // })
        /** **/

        /** Grouped Custom Profiles Logic **/
        let tmpCustomProfiles = resp.custom_profiles.nodes.map((el) => { return {
          text: el.custom_profile,
          value: el.custom_profile,
          disabled: false
        }})  
        this.availableCustomProfiles = this.getGroupedCustomProfiles(tmpCustomProfiles)
        // this.customProfiles.forEach((custom_profile) => {
        //   if(!this.availableCustomProfiles.includes(custom_profile))
        //     custom_profile.disabled = true
        // })
        /** **/

        this.availableCountries = resp.countries.nodes.map(el => el.country)
        // this.countries.forEach((country) => {
        //   if(!this.availableCountries.includes(country.value))
        //     country.disabled = true
        // })
        this.setActiveResponse()
        this.setChartData()
      }
    },
    getGroupedProfiles(arr){
      let out = []
      arr.forEach((el) => {
        // console.log("el --",el)
        let tmp = this.profilesGroups.filter((el2) => el2.value.includes(el.text))
        if (tmp.length > 0 && !out.includes(tmp))          
          out = out.concat(tmp)        
      })
      return [...new Set(out)]      
    },
    getGroupedCustomProfiles(arr){
      let out = []
      arr.forEach((el) => {
        // console.log("el --",el)
        let tmp = this.customProfilesGroups.filter((el2) => el2.value.includes(el.text))
        if (tmp.length > 0 && !out.includes(tmp))          
          out = out.concat(tmp)        
      })
      return [...new Set(out)]      
    },
    setActiveResponse(){
      let max = Math.max.apply(null, this.responses_count)
      let targetIndex = this.responses_count.indexOf(max)
      this.activeResponse = this.responses.find((p) => this.labels[targetIndex] == p.response_id)
      //console.log("max", this.activeProduct)
    },
    clearFilters(){
      this.selectedProfiles = []
      this.selectedCountries = []
      this.selectedCustomProfiles = []
      this.profiles.forEach((profile) => {
        profile.disabled = false
      })
      this.customProfiles.forEach((cp) => {
        cp.disabled = false
      })
      this.fetchData()
    },
    setChartData(){
      this.datacollection = {
        labels: this.labels,
        datasets: [
          {
            label: "Votes",
            backgroundColor: '#e53e3e',
            data: this.responses_count            
          }
        ]
      }
    },
    questionText(qId){
      
      let poll = PollDB.polls.find((p)=> p.action.data["question-id"] == qId)
      if (poll == undefined)
        return {}
      else
        return poll.action.data.question.default
    }
    
  },
  computed:{
    labels(){
      let responses_ids = this.responses.map(el => el.response_id)
      return [...new Set(responses_ids)]
    },
    showCustomProfile(){
      let tmp = this.selectedProfiles.join().split(',')
      //console.log ("show",tmp)
      if ( tmp.includes("AUDIENCIA_VIP") || tmp.includes("AUDIENCIA_GENERAL") || tmp.includes("PARTNER") || tmp.includes("EXHIBITOR_AGENT") || tmp.includes("ORGANIZER_FIRA") || tmp.includes("EXHIBITOR_ADMIN") )
        return true
      else 
        return false
    },
    responses_count(){
      let out = []        
      this.labels.forEach((respId) => {
        let tmp = this.responses.filter((el) => {return el.response_id == respId})
        let total = 0
        tmp.forEach((el) => { total += el.count_response_id})
        out.push(total)
      })

      return out      
    },
    pollQuestion(){
      let poll = PollDB.polls.find((p)=> p.action.data["question-id"] == this.activeQuestion)
      if (poll == undefined)
        return {}
      else
        return poll.action.data
    },
    questionsObj(){
      let out = []
      return this.questions.map((q) => {
        return {
          value: q,
          text: this.questionText(q)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
